<template>
    <section>
        <div class="page-head">
            <div>
                <h1 class="page-title">Usuarios</h1>
                <p class="page-sub">Cuentas con acceso al sistema</p>
            </div>
            <div class="page-actions">
                <b-button type="is-primary" icon-left="plus" tag="router-link" :to="{ path: '/agregar-usuario' }">Agregar usuario</b-button>
            </div>
        </div>
        <mensaje-inicial :titulo="'No se han registrado usuarios'" :subtitulo="'Agrega algunos usuarios'" v-if="usuarios.length < 1" />
        <div class="table-card" v-else>
        <b-table
        :data="usuarios">
            <b-table-column field="usuario" label="Nombre de usuario" sortable searchable v-slot="props">
                {{ props.row.usuario }}
            </b-table-column>

            <b-table-column field="nombre" label="Nombre completo" sortable searchable v-slot="props">
                {{ props.row.nombre }}
            </b-table-column>

            <b-table-column field="telefono" label="Teléfono" sortable searchable v-slot="props">
                {{ props.row.telefono }}
            </b-table-column>

            <b-table-column field="eliminar" label="Eliminar" v-slot="props">
                <b-button size="is-small" type="is-danger is-light" icon-left="delete" @click="eliminar(props.row.id)">Eliminar</b-button>
            </b-table-column>

            <b-table-column field="editar" label="Editar" v-slot="props">
                <b-button size="is-small" type="is-info is-light" icon-left="pen" @click="editar(props.row.id)">Editar</b-button>
            </b-table-column>
        </b-table>
        </div>
        <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false"></b-loading>
    </section>
</template>
<script>
    import MensajeInicial from '../Extras/MensajeInicial'
    import HttpService from '../../Servicios/HttpService'

    export default {
        name: "UsuariosComponent",
        components: { MensajeInicial },

        data:()=>({
            cargando: false,
            usuarios: []
        }),

        mounted(){
            this.obtenerUsuarios()
        },

        methods: {
            async eliminar(idUsuario){
                // obtener datos del usuario localmente para limpiar grupo si aplica
                const usuario = this.usuarios.find(u => Number(u.id) === Number(idUsuario)) || null

                this.$buefy.dialog.confirm({
                    title: 'Eliminar usuario',
                    message: 'Seguro que quieres <b>eliminar</b> este usuario? Esta acción no se puede revertir.',
                    confirmText: 'Sí, eliminar',
                    cancelText: 'Cancelar',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => {
                        this.cargando = true
                        HttpService.eliminar('usuarios.php',{
                            accion: 'eliminar',
                            id: idUsuario
                        })
                        .then(resultado => {
                            if(!resultado) {
                                this.$buefy.toast.open('Error al eliminar')
                                this.cargando = false
                                return
                            }

                            if(resultado){
                                this.cargando = false
                                this.$buefy.toast.open({
                                    type: 'is-info',
                                    message: 'Usuario eliminado.'
                                })

                                // limpiar jefe en localStorage si el usuario era jefe de algún grupo
                                try {
                                    if (usuario && usuario.grupoId) {
                                        const raw = localStorage.getItem('grupos')
                                        const grupos = raw ? JSON.parse(raw) : []
                                        const idx = grupos.findIndex(g => Number(g.id) === Number(usuario.grupoId))
                                        if (idx !== -1) {
                                            if (grupos[idx].jefe === usuario.nombre) {
                                                grupos[idx].jefe = ''
                                                localStorage.setItem('grupos', JSON.stringify(grupos))
                                                window.dispatchEvent(new Event('gruposUpdated'))
                                            }
                                        }
                                    }
                                } catch(e) {
                                    console.warn('No se pudo limpiar grupo en localStorage', e)
                                }

                                this.obtenerUsuarios()
                            }
                        })
                    }
                })
            },

            editar(idUsuario){
                this.$router.push({
                    name: "EditarUsuario",
                    params: { id: idUsuario}
                })
            },

            obtenerUsuarios(){
                this.cargando = true
                let payload = {
                    accion: 'obtener'
                }
                HttpService.obtenerConConsultas('usuarios.php', payload)
                .then(usuarios => {
                    this.usuarios = usuarios
                    this.cargando = false
                })
            }
        }
    }
</script>